export default __webpack_public_path__ + "static/frame-007-d58856264bb089fbb95b2ae0383e344c.png";